export default {
  UPDATE_OPTION: 'EUROPA_UPDATE_OPTION',
  UPDATE_FILTER: 'EUROPA_UPDATE_FILTER',
  UPDATE_DATA_PARAMETER: 'EUROPA_UPDATE_DATA_PARAMETER',
  TOGGLE_FILE_TO_DOWNLOAD: 'EUROPA_TOGGLE_FILE_TO_DOWNLOAD',
};
